import {
  AccessTimeRounded,
  AssessmentRounded,
  BeachAccessRounded,
  FactCheckRounded,
  PeopleAltRounded,
} from "@mui/icons-material";

export const reportCategories = [
  {
    key: "time-productivity",
    title: "Time & Productivity",
    description:
      "Track working hours, time analysis and productivity-focused reports.",
    accent: "#12905B",
    softAccent: "#EEF9F3",
    borderColor: "#CBE9D8",
    icon: AccessTimeRounded,
    reports: [
      {
        key: "summarized-working-hours",
        label: "Working Hours Summary",
        reportName: "Summarized working hours",
      },
      {
        key: "detailed-working-hours",
        label: "Working Hours Detail",
        reportName: "Detailed working hours",
      },
      {
        key: "working-hours-report",
        label: "Working Hours Report",
        reportName: "Working Hours Report",
      },
      {
        key: "time-card",
        label: "Time Card",
        reportName: "Time card",
      },
      {
        key: "overtime-analysis",
        label: "Overtime Analysis",
        reportName: "Overtime Report",
      },
    ],
  },
  {
    key: "attendance-compliance",
    title: "Attendance & Compliance",
    description:
      "Monitor attendance anomalies, punch records and device-linked compliance data.",
    accent: "#D97706",
    softAccent: "#FFF6EA",
    borderColor: "#F3D5AE",
    icon: FactCheckRounded,
    reports: [
      {
        key: "attendance-exceptions",
        label: "Attendance Anomalies",
        reportName: "Attendance Anomalies Report",
      },
      {
        key: "punch-entry",
        label: "Punch Entry",
        reportName: "Punch Entry",
      },
      {
        key: "raw-punch-entry",
        label: "Raw Punch Entry",
        reportName: "Raw Punch Entry",
      },
      {
        key: "adjustment-entry",
        label: "Adjustment Entry",
        reportName: "Adjustment Entry",
      },
      {
        key: "break-report",
        label: "Break Report",
        reportName: "Break",
      },
      {
        key: "employee-attendance",
        label: "Employee Attendance",
        reportName: "Employee Attendance Report",
      },
      {
        key: "device-status",
        label: "Device Status",
        reportName: "Device Status Report",
      },
      {
        key: "punch-processing-exceptions",
        label: "Punch Processing Exceptions",
        reportName: "Punch Processing Exceptions",
        description:
          "View punch entries that were not processed in the global event pipeline, with the reason and the stage where they are blocked.",
      },
    ],
  },
  {
    key: "leave-absence",
    title: "Leave & Absence",
    description:
      "Review leave, permission and absence-related trends from one place.",
    accent: "#7C3AED",
    softAccent: "#F7F0FF",
    borderColor: "#E4D3FA",
    icon: BeachAccessRounded,
    reports: [
      {
        key: "leave-permission",
        label: "Leave & Permission",
        reportName: "Leave and Permission Reports",
      },
    ],
  },
  {
    key: "daily-work",
    title: "Daily Work",
    description:
      "Follow day-wise reporting and manager review activity across the team.",
    accent: "#2563EB",
    softAccent: "#EEF4FF",
    borderColor: "#CFE0FF",
    icon: AssessmentRounded,
    reports: [
      {
        key: "daily-report",
        label: "Daily Report",
        reportName: "Daily Report",
      },
      {
        key: "eod-report",
        label: "EOD Report",
        reportName: "EOD Report",
      },
    ],
  },
  {
    key: "workforce",
    title: "Workforce",
    description:
      "Analyze team availability, staffing posture and workforce-level summaries.",
    accent: "#D4A106",
    softAccent: "#FFF8E1",
    borderColor: "#F1DE9A",
    icon: PeopleAltRounded,
    reports: [
      {
        key: "workforce-status",
        label: "Workforce Status",
        reportName: "Workforce Status Report",
      },
    ],
  },
];

export const reportRegistry = reportCategories.flatMap((category) =>
  category.reports.map((report) => ({
    ...report,
    categoryKey: category.key,
  })),
);
